const prefix = 'sidebar__';
const SidebarResources = {
    defaultToggleBtnClassName: `${prefix}toggle-btn`,
    defaultIconBtnClassName: `${prefix}chevron_icon-button`,
    containerClassName: `${prefix}container`,
    tooltipClassName: `${prefix}tooltip`,
    itemsClassName: `${prefix}items`,
    iconClassName: `${prefix}chevron-icon`
};
export default SidebarResources;